import React, { useState, useEffect } from 'react';
import SliderComponent from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';

import './RangeSlider.scss';

const RangeSlider = ({ labels, value, onChange, max, min, tooltip = true }) => {
  const [componentValue, setComponentValue] = useState(value);
  useEffect(() => {
    setComponentValue(value);
  }, [value]);
  return (
    <div className="slider">
      <SliderComponent
        min={min || 0}
        max={max || 100}
        // value={horizontal}
        value={componentValue}
        labels={labels}
        // onChange={value => setHorizontal(value)}
        onChangeComplete={() => onChange(componentValue)}
        onChange={value => setComponentValue(value)}
        tooltip={tooltip}
      />
    </div>
  );
};

export default RangeSlider;
